"use client";

import { iconsList } from "@tabler/icons-react";
import IHVIconProps from "./IHVIcon";
import iconList, { IconKey, OldIconKey, oldIconList } from "./iconList";
import { createElement } from "react";

const svgDefaultProperties: { [key: string]: number | string } = {
  width: 24,
  height: 24,
  strokeWidth: 1.5,
};

const HVIcon = ({
  name,
  scale = "medium",
  theme = "line",
  svgProps = svgDefaultProperties,
  styleClass,
  size = 24,
  cameraStatus,
}: IHVIconProps) => {
  let iconKey: IconKey;
  if (cameraStatus) {
    iconKey = `${name}-${cameraStatus}` as IconKey;
  } else {
    iconKey = `${name}-${scale}-${theme}` as IconKey;
  }
  let selectedIcon: React.ElementType;
  if(iconList[iconKey]) {
    selectedIcon = iconList[iconKey];
  } else {
    const oldIconName = name as OldIconKey;
    selectedIcon = oldIconList[oldIconName];
  }

  if (theme === "fill") {
    svgDefaultProperties["fill"] = "var(--hv-icon-normal-primary)";
    svgDefaultProperties["stroke"] = "none";
  } else {
    svgDefaultProperties["fill"] = "none";
    svgDefaultProperties["stroke"] = "var(--hv-icon-normal-primary)";
  }
  if (cameraStatus) {
    svgDefaultProperties["stroke"] = "var(--hv-icon-normal-primary)";
  }
  svgDefaultProperties["height"] = size;
  svgDefaultProperties["width"] = size;

  return (
    <>
      {createElement(selectedIcon, {
        className: styleClass,
        ...svgDefaultProperties,
        ...svgProps,
      })}
    </>
  );
};

export default HVIcon;
